module.exports = __webpack_public_path__ + "static/media/NeutralSmiley.62990606.png";